export const parseErrorMessage = (error: any) => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (error.message) return error.message;
  if (error.cause) return JSON.stringify(error.cause);
  return JSON.stringify(error);
};